import { useTranslation } from "react-i18next";
import { FiLayers } from "react-icons/fi";
import { ProjectStatus, useGetProjectsQuery } from "../../../autogen/bff-api";
import { useDisplayDate } from "../../../common/formatting/useDisplayDate";
import { urls } from "../../../urls";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

const DISPLAY_LIMIT = 5;

export const OngoingProjectsPanel = () => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();

  const { data, isLoading, isError } = useGetProjectsQuery({ status: ProjectStatus.Ongoing, limit: DISPLAY_LIMIT });
  const projects = data?.projects ?? [];

  return (
    <HomePanel
      titleKey="Ongoing projects"
      icon={FiLayers}
      seeAllTo={`${urls.app.projects.viewAll}?status=${ProjectStatus.Ongoing}`}
      isLoading={isLoading}
      isError={isError}
      isEmpty={projects.length === 0}
      emptyKey="No ongoing projects"
    >
      <PanelTable headers={[t("Name"), t("End date")]}>
        {projects.map((project) => (
          <PanelRow key={project.id} to={urls.app.projects.view.go(project.id)}>
            <TitleCell title={project.name} subtitle={project.parent?.name ?? undefined} />
            <MutedCell>{project.endDate ? displayDate(project.endDate) : "—"}</MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
